"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ManagedAuSidebarCollapser = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _constants = require("../../constants");
var _context;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "au_sidebar_collapser-module__container___tSwcI",
  "collapsed": "au_sidebar_collapser-module__collapsed___Kd4zY",
  "button": "au_sidebar_collapser-module__button___RPzKh"
};
class ManagedAuSidebarCollapser extends _react.default.PureComponent {
  static propTypes = {
    className: T.string,
    isOpen: T.bool.isRequired,
    onClick: T.func
  };
  static defaultProps = {
    onClick: _constants.NOOP
  };
  render() {
    const {
      children,
      className,
      isOpen,
      onClick
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, {
        [styles.collapsed]: !isOpen
      }, className)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.button, {
        [styles.collapsed]: !isOpen
      }, className),
      onClick: onClick
    }), isOpen && children);
  }
}
exports.ManagedAuSidebarCollapser = ManagedAuSidebarCollapser;
class AuSidebarCollapser extends _react.default.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true
    };
  }
  static propTypes = {
    className: T.string,
    onExpanded: T.func,
    onCollapsed: T.func
  };
  static defaultProps = {
    onExpanded: _constants.NOOP,
    onCollapsed: _constants.NOOP
  };
  handleClick = (0, _bind.default)(_context = this.handleClick).call(_context, this);
  handleClick() {
    const {
      onExpanded,
      onCollapsed
    } = this.props;
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }), () => {
      if (this.state.isOpen) {
        onExpanded();
      } else {
        onCollapsed();
      }
    });
  }
  render() {
    const {
      children,
      className
    } = this.props;
    const {
      isOpen
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(ManagedAuSidebarCollapser, {
      className: className,
      isOpen: isOpen,
      onClick: this.handleClick
    }, children);
  }
}
exports.default = AuSidebarCollapser;